import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleFieldDeleteService } from '../../services';

export const fetchModuleFieldDelete = createAsyncThunk(
    'moduleFieldDelete/fetchModuleFieldDelete',
    async ({ id }) => {
        const response = await ModuleFieldDeleteService(id)
        return response.result
    }
)

const moduleFieldDeleteSlice = createSlice({
    name: 'moduleFieldDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleFieldDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleFieldDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleFieldDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleFieldDeleteSlice.reducer;
